module.exports = __webpack_public_path__ + "img/1F6B9.292ed7b2.svg";